import React from "react";
import { useParams } from "react-router-dom";
import ServiceWidget from "./ServiceWidget";

const IframeService = () => {
  const { widgetId } = useParams();

  return <ServiceWidget widgetId={widgetId} />;
};

export default IframeService;
